/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

var normalizeComponent = require('../../normalize-component-d885d5ff.js');
var vuex_esmBundler = require('../../vuex.esm-bundler-607ad4c2.js');
var base = require('../../base-cc3cef3f.js');
var regexpExecAbstract = require('../../regexp-exec-abstract-6e247220.js');
var toString = require('../../to-string-e5a81da9.js');
require('../../es.string.search-1012963e.js');
require('vue');
require('../../index-1651dbe5.js');
require('../../index-5d056502.js');
require('../../es.number.constructor-17a0e7eb.js');
require('../../themeContent-f8df7540.js');

var floor = Math.floor;
var charAt = normalizeComponent.functionUncurryThis(''.charAt);
var replace = normalizeComponent.functionUncurryThis(''.replace);
var stringSlice$1 = normalizeComponent.functionUncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = normalizeComponent.toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$1(str, 0, position);
      case "'": return stringSlice$1(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$1(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var REPLACE = normalizeComponent.wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = normalizeComponent.functionUncurryThis([].concat);
var push = normalizeComponent.functionUncurryThis([].push);
var stringIndexOf = normalizeComponent.functionUncurryThis(''.indexOf);
var stringSlice = normalizeComponent.functionUncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !normalizeComponent.fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
regexpExecAbstract.fixRegexpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = normalizeComponent.requireObjectCoercible(this);
      var replacer = normalizeComponent.isNullOrUndefined(searchValue) ? undefined : normalizeComponent.getMethod(searchValue, REPLACE);
      return replacer
        ? normalizeComponent.functionCall(replacer, searchValue, O, replaceValue)
        : normalizeComponent.functionCall(nativeReplace, toString.toString_1(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = normalizeComponent.anObject(this);
      var S = toString.toString_1(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = normalizeComponent.isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString.toString_1(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regexpExecAbstract.regexpExecAbstract(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString.toString_1(result[0]);
        if (matchStr === '') rx.lastIndex = base.advanceStringIndex(S, toString.toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString.toString_1(result[0]);
        var position = max(min(toString.toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString.toString_1(base.functionApply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var script = {
  name: 'HeaderWeb',
  extends: base.__vue_component__,
  data: function data() {
    return {
      igShadow: ['tokens', 'userWithdraw', 'userAuthDetail']
    };
  },
  props: ['userIsOpenAction'],
  watch: {
    isLogin: function isLogin() {
      this.userIsOpen();
    },
    '$route': {
      handler: function handler(curVal, oldVal) {
        if (this.$route.path.includes('academy')) {
          this.langs = [{
            code: 'en',
            name: 'English'
          },
          // {code: 'kr', name: '한국어', cursor: 'cursors'},
          {
            code: 'ru',
            name: 'Русский',
            cursor: 'cursors'
          }, {
            code: 'pt-br',
            name: 'Português (Brasil)',
            cursor: 'cursors'
          }
          // { code: 'jp', name: '日本語' },
          // {code: 'hk', name: '繁體中文', cursor: 'cursors'}
          ];
        } else {
          this.langs = [{
            code: 'en',
            name: 'English'
          },
          // {code: 'kr', name: '한국어'},
          {
            code: 'ru',
            name: 'Русский'
          }, {
            code: 'pt-br',
            name: 'Português (Brasil)'
          }
          // { code: 'jp', name: '日本語' },
          // {code: 'hk', name: '繁體中文'}
          ];
        }

        if (curVal.path.indexOf('/spot') > -1 && curVal.path.indexOf('/spot') < 4) {
          this.isBiBi = true;
        } else {
          this.isBiBi = false;
        }
        if (curVal.path.indexOf('/simulation-perpetual') > -1) {
          this.isSimulationPerpetual = true;
        } else {
          this.isSimulationPerpetual = false;
        }
        this.spotSymbol = window.sessionStorage.getItem('spotSymbol') || '';
        this.perpetualSymbol = window.sessionStorage.getItem('perpetualSymbol') || '';
      },
      immediate: true
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.userIsOpen();
    this.isLogin && this.showVipLevelAction();
  },
  methods: vuex_esmBundler._objectSpread2(vuex_esmBundler._objectSpread2({}, vuex_esmBundler.mapActions('user', ['doLogout', 'updateLang'])), {}, {
    userIsOpen: function userIsOpen() {
      var _this = this;
      return vuex_esmBundler._asyncToGenerator( /*#__PURE__*/vuex_esmBundler._regeneratorRuntime().mark(function _callee() {
        var res;
        return vuex_esmBundler._regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.userIsOpenAction();
            case 2:
              res = _context.sent;
              if (res.success) {
                _this.userIsOpenTrue = res.data;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    setLang: function setLang(base) {
      this.languageClict = false;
      this.menuTrue = false;
      if (!this.$route.path.includes('academy')) {
        var lang = window.location.pathname.split('/')[1];
        if (lang) {
          var url = window.location.origin + window.location.pathname.replace(lang, base) + window.location.search;
          window.location.href = url;
        } else {
          var _url = window.location.href;
          window.location.href = _url + base + '/';
        }
        if (this.isLogin) {
          this.updateLang({
            lang: base
          });
        }
        this.$store.commit('common/LOCALE', base);
        this.$setCookie('lang', base, 'y1');
      }
    },
    setCurrey: function setCurrey(base, index) {
      this.currencyClict = false;
      this.languageClict = false;
      this.menuTrue = false;
      this.$setCookie('current', index, 'y1');
      this.$store.commit('common/CURRENT_CURRENCY', base);
    },
    logout: function logout() {
      var userName = window.localStorage.getItem('userName');
      window.localStorage.clear();
      window.localStorage.setItem('userName', userName);
      this.doLogout();
      this.$router.push({
        path: '/'
      });
    }
  }),
  beforeDestroy: function beforeDestroy() {}
};

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent.normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

__vue_component__.install = function (Vue) {
  Vue.component(__vue_component__.name, __vue_component__);
};

module.exports = __vue_component__;
